/* istanbul ignore file */
/**
 * Badge component theme configuration.
 */

export const badgeComponentConfig = {
  badge: {
    root: {
      borderRadius: '{border.radius.xl}',
      padding: '0 4px',
      fontSize: '10px',
      fontWeight: '400',
      minWidth: '12px',
      height: '14px',
    },
    dot: {
      size: '4px',
    },
    lg: {
      fontSize: '12px',
      minWidth: '16px',
      height: '16px',
    },
    xl: {
      fontSize: '12px',
      minWidth: '18px',
      height: '18px',
    },
    colorScheme: {
      light: {
        primary: {
          background: '{primary.600}',
          color: '{surface.0}',
        },
        success: {
          background: '{success.500}',
          color: '{surface.0}',
        },
        info: {
          background: '{information.500}',
          color: '{surface.0}',
        },
        warn: {
          background: '{warning.450}',
          color: '{surface.0}',
        },
        danger: {
          background: '{error.550}',
          color: '{surface.0}',
        },
      },
    },
  },
};
